import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=a3c91d0a&scoped=true&"
import script from "./TeacherProfile.vue?vue&type=script&lang=js&"
export * from "./TeacherProfile.vue?vue&type=script&lang=js&"
import style0 from "./TeacherProfile.vue?vue&type=style&index=0&id=a3c91d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c91d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardSubtitle,VChip,VChipGroup,VContainer,VDivider,VIcon})
